import { useSelector } from 'react-redux';
import * as R from 'ramda';

import { reactcursively } from 'utils/react';
import UserBadge from 'components/userBadge/UserBadge';
import { PosPlugin } from 'plugins/plugin';

import { getCustomerPropertyFn } from '../utils';

const UIVisibleCustomerInformation: PosPlugin['UIVisibleCustomerInformation'] = ({
  currentCustomer,
  children,
}) => {
  const { getCustomerProperty } = useSelector(getCustomerPropertyFn);
  return reactcursively(
    R.when(
      R.pathEq(['type', 'name'], UserBadge.name),
      R.pipe(
        R.assocPath(
          ['props', 'customerCardNumber'],
          getCustomerProperty('customerCardNumber', currentCustomer),
        ),
        R.assocPath(['props', 'customerGroup'], ''),
      ),
    ),
  )(children);
};

export default UIVisibleCustomerInformation;
